import spot1 from '../assets/spot1.png'
import spot2 from '../assets/spot2.png'
import spot3 from '../assets/spot3.png'
import spot4 from '../assets/spot4.png'

const AnimatedDots = () => {
    return (
        <div className='post-abs z-0'>
            <div className='spot location1'><img src={spot1} className="w-10"/></div>
            <div className='spot location3'><img src={spot2} className="w-60"/></div>
            <div className='spot location1'><img src={spot3} className="w-10 mt--5"/></div>
            <div className='spot location1'><img src={spot4} className="w-5 mt--10"/></div>
            <div className='spot location4'><img src={spot4} className="w-20 mt--20"/></div>
        </div>
    );
}

export default AnimatedDots